<template>
  <div class="homeArticleManagement">
    <!-- <div class="theHeader">
      <div></div>
      <div class="rightContent">
        <div class="dateWap">
        <el-date-picker
          class="dateWap"
          v-model=""
          type="daterange"
          range-separator="To"
          start-placeholder="支付开始时间"
          end-placeholder="支付结束时间"
          format="YYYY/MM/DD"
          value-format="YYYY-MM-DD"
        />
        </div>
        <div class="inputWap">
          <el-input
            class="inputStyle"
            v-model="input"
            placeholder="Please input"
          />
          <div class="buttonStyle" @click="articleGetUserArticle()">搜索</div>
        </div>
      </div>
    </div> -->
    <el-dialog
      v-model="pageData.orderDetailsShow"
      title="订单详情"
      width="50%"
    >
      <div class="orderDetailWap">
        <div class="item_">
          <div>订单号：{{pageData.orderDetails.orderCode}}</div>
          <div>订单状态：{{ pageData.orderDetails.state == 1 ? "交易成功" : "交易失败" }}</div>
        </div>
        <div class="item_">
          <div>下单时间：{{pageData.orderDetails.createTime}}</div>
          <div>支付方式：{{pageData.orderDetails.payWay == 1 ? "微信" : "支付宝"}}</div>
        </div>
      </div>
      <div class="orderDetailWap">
        <div class="item_">
          <div>支付信息</div>
          <div></div>
        </div>
        <div class="item_">
          <div>交易单号：{{pageData.orderDetails.orderCode}}</div>
          <div>商户单号：{{pageData.orderDetails.shoppingInfoList.resourceCode}}</div>
        </div>
      </div>
      <div class="orderDetailWap">
        <div class="item_">
          <div>买家信息</div>
          <div></div>
        </div>
        <div class="item_">
          <div>买家昵称：{{pageData.orderDetails.userName}}</div>
          <div>联系方式：{{pageData.orderDetails.userPhone}}</div>
        </div>
      </div>
      <div class="orderDetailWapStyleTwo">
        <div class="item_">
          <div>购买方式</div>
          <div>{{pageData.orderDetails.payWay == 1 ? "微信" : "支付宝"}}</div>
        </div>
        <div class="item_">
          <div>授权时间</div>
          <div>{{pageData.orderDetails.shoppingInfoList.rightsCategoryList.effectiveTime || '-'}}年</div>
        </div>
        <div class="item_">
          <div>独家期</div>
          <div>{{pageData.orderDetails.shoppingInfoList.rightsCategoryList.soleEffectiveTime || '-'}}个月</div>
        </div>
      </div>
      <div class="orderDetailWapStyleThree">
        <div class="title_">授权范围</div>
        <div class="content_">
          <div v-for="item in pageData.orderDetails.shoppingInfoList.rightsCategoryList.rightsCategoryArr" :key="item">
              {{item.name}}
          </div>
        </div>
      </div>
      <div class="orderDetailWapStyleFour">
        <div>订单合计1件商品，实付:</div>
        <div>¥{{pageData.orderDetails.discountPrice}}</div>
      </div>
    </el-dialog>
    <div class="tableWtyle">
      <el-table
        :data="pageData.tableData"
        height="500"
        style="width: 100%"
        :header-cell-style="{
          background: '#F5F7FA',
          color: '#303133',
          fontWeight: '800',
        }"
      >
        <el-table-column label="">
          <template #default="scope">
            <div>
              {{ (totalnum.page - 1) * totalnum.pageSize + (scope.$index + 1) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="订单编号">
          <template #default="scope">
            <div>
              {{ scope.row.orderCode || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="文章标题">
          <template #default="scope">
            <div>
              {{ scope.row.shoppingInfoList.resourceName || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="支付金额">
          <template #default="scope">
            <div>
              {{ scope.row.discountPrice || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="交易状态">
          <template #default="scope">
            <div>
              {{ scope.row.state == 1 ? "交易成功" : "交易失败" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="支付方式">
          <template #default="scope">
            <div>
              {{ scope.row.payWay == 1 ? "微信" : "支付宝" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="下单时间">
          <template #default="scope">
            <div>
              {{ scope.row.createTime || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="支付时间">
          <template #default="scope">
            <div>
              {{ scope.row.payTime || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template #default="scope">
            <el-button type="text" @click="orderDetails(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagingComponent
      @handleCurrentChangeSub="noChangePagination"
      :currentPage="totalnum.page"
      :rows="totalnum.pageSize"
      :total="totalnum.total"
    />
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { getUserOrderList } from "../api/interfaceList";
import { reactive, computed, onMounted } from "vue";
import pagingComponent from "@/components/pagingComponent/index";
export default {
  name: "homeArticleManagement",
  setup() {
    let pageData = reactive({
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: null,
      orderDetailsShow: false,
      orderDetails: "",
    });
    let totalnum = computed(() => {
      return pageData.page;
    })

    function noChangePagination(res) {
      pageData.tableData = [];
      pageData.page.page = res;
      getUserOrderListFun();
    }

    function getUserOrderListFun() {
      getUserOrderList({
        userCode: JSON.parse(Cookies.get("userInformation")).userCode,
        page: pageData.page.page,
        pageSize: pageData.page.pageSize,
      }).then((res) => {
        if (res.code == 1) {
          pageData.tableData = res.data.records;
          pageData.page.total = res.data.pages;
        }
      });
    }

    function orderDetails(e) {
      let list = [
        {
          name: "发表权",
          type: 0,
        },
        {
          name: "署名权",
          type: 1,
        },
        {
          name: "修改权",
          type: 2,
        },
        {
          name: "保护作品完整权",
          type: 3,
        },
        {
          name: "复制权",
          type: 4,
        },
        {
          name: "发行权",
          type: 5,
        },
        {
          name: "出租权",
          type: 6,
        },
        {
          name: "展览权",
          type: 7,
        },
        {
          name: "表演权",
          type: 8,
        },
        {
          name: "放映权",
          type: 9,
        },
        {
          name: "广播权",
          type: 10,
        },
        {
          name: "信息网络传播权",
          type: 11,
        },
        {
          name: "摄制权",
          type: 12,
        },
        {
          name: "改编权",
          type: 13,
        },
        {
          name: "翻译权",
          type: 14,
        },
        {
          name: "汇编权",
          type: 15,
        },
        {
          name: "其他",
          type: 16,
        },
      ];
      let arr = []
      list.map(item=>{
          e.shoppingInfoList.rightsCategoryList.rightsCategoryArr.map(items=>{
              if(item.type == items){
                  arr.push(item)
              }
          })
      })
      e.shoppingInfoList.rightsCategoryList.rightsCategoryArr = arr
      pageData.orderDetails = e;
      pageData.orderDetailsShow = true;
      console.log(e)
    }

    onMounted(() => {
      getUserOrderListFun();
    });
    return {
      pageData,
      totalnum,
      noChangePagination,
      getUserOrderListFun,
      orderDetails,
    };
  },
  components: {
    pagingComponent,
  },
};
</script>
<style lang="scss" scoped>
.homeArticleManagement {
  width: 1050px;
  background: #ffffff;
  border-radius: 8px;
  padding: 16px 30px;
  box-sizing: border-box;
  .orderDetailWapStyleThree {
    .content_ {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      div {
        padding: 5px 10px;
        box-sizing: border-box;
        border-radius: 20px;
        background: #f5f7fa;
        color: #59c3ee;
        font-weight: 700;
        margin: 10px 10px 0 0;
      }
    }
  }
  .orderDetailWapStyleFour {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    div {
      font-size: 12px;
      font-family: AlibabaPuHuiTiR;
      font-weight: 600;
    }
    div:nth-of-type(1) {
      color: #606266;
      margin-right: 10%;
    }
    div:nth-of-type(2) {
      color: #59c3ee;
    }
  }
  .orderDetailWapStyleTwo {
    padding: 16px 10px;
    box-sizing: border-box;
    .item_ {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      div:nth-of-type(1) {
        width: 10%;
        font-size: 13px;
        font-family: AlibabaPuHuiTiR;
        color: #606266;
      }
      div:nth-of-type(2) {
        font-size: 15px;
        font-weight: 600;
        font-family: AlibabaPuHuiTiR;
        color: #606266;
      }
    }
  }
  .orderDetailWap {
    width: 100%;
    padding: 16px 10px;
    box-sizing: border-box;
    border-bottom: 1px #e6e6e6 solid;
    .item_:last-of-type {
      margin-bottom: 0;
    }
    .item_ {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      div {
        width: 50%;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #606266;
      }
    }
  }
  .tableWtyle {
    width: 100%;
    margin-top: 16px;
    div {
      width: 100%;
      text-align: center;
    }
  }
  .theHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12px;
    border-bottom: 1px solid #f7f7f7;
    .rightContent {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .dateWap {
        width: 300px;
        margin-right: 32px;
      }
      .inputWap {
        // width: 237px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .inputStyle {
          width: 157px;
        }
        .buttonStyle {
          width: 72px;
          height: 40px;
          font-size: 13px;
          font-family: AlibabaPuHuiTiM;
          color: #ffffff;
          line-height: 40px;
          text-align: center;
          background: #008aea;
          border-radius: 6px;
          text-align: center;
          cursor: pointer;
          transition: 0.3s all;
        }
        .buttonStyle:hover {
          background: #55b2fb;
        }
      }
    }
  }
}
</style>
